import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: 'Temperature Chart',
  },
  timeWindow: 1,
  childProps: {
    type: 'temperature',
    yMin: 7 * 4,
    yAxisLabel: 'Temperature (C)',
    title: chartTitles.temperature,
  },
})
